import React from "react";
import { useParams } from "react-router-dom";
import TourPage from "./TourPage";
import { islandTours } from "./islandData"; //  named import

const SubmenuData = () => {
  const { island } = useParams();
  const data = islandTours[island];

  if (!data) return <h2>Island not found</h2>;

  return <TourPage {...data} />;
};

export default SubmenuData;
